import { ref, onMounted } from 'vue'
import { resourcesService } from '@/api/resources.service'

export function useProductDetailsOtc(productId: number) {
    const pflichttextUrl = ref('')

    async function initializeOtcSpecificData() {
        pflichttextUrl.value = await resourcesService.pflichttextUrl()
    }

    function createSearchHistoryEntry(currentUrl: string) {
        const historyKey = 'searchHistory'
        const getHistory = (): any => {
            const raw = localStorage.getItem(historyKey)
            return raw && raw !== 'undefined' ? JSON.parse(raw) : {}
        }
        const setHistory = (h: any) => localStorage.setItem(historyKey, JSON.stringify(h))

        const historyObj = getHistory()
        historyObj.psLocOrigin = historyObj.psLoc
        historyObj.psLoc = currentUrl.replace(location.search, '')
        historyObj.product = productId
        historyObj.sip = true
        setHistory(historyObj)
    }

    function gotoPflichttext(praeparatId: number) {
        const currentUrl = window.location.toString()
        createSearchHistoryEntry(currentUrl)

        if (pflichttextUrl.value) {
            const target = `${pflichttextUrl.value}?product=${productId}&praeparat=${praeparatId}`
            window.open(target, '_self')
        }
    }

    onMounted(initializeOtcSpecificData)

    return {
        pflichttextUrl,
        gotoPflichttext
    }
}